export default {
  changeGiftType(state, type) {
    state.type = type;
  },
  changeInstruction(state) {
    state.isSelected = !state.isSelected;
  },
  changeIsNative(state, data) {
    state.isNative = data
  }
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/goldSale/store/mutations.js